export default class Menu {
  constructor(el) {
    this.DOM = { el: el };
    this.DOM.openButton = document.querySelector('.nav-responsive__item--menu a');
    this.DOM.closeButton = document.querySelector('.menu-responsive__item--close a');
    this.state = {};
    this.state.isOpen = false;

    this.toggle = this.toggle.bind(this);

    this.init();
  }

  init() {
    if (!this.DOM.el) return;
    setTimeout(() => this.DOM.el.style.display = 'block', 500);
    this.bindEvents();
  }

  bindEvents() {
    this.DOM.openButton.addEventListener('click', this.toggle);
    this.DOM.closeButton.addEventListener('click', this.toggle);
  }

  toggle(e) {
    e.preventDefault();
    this.DOM.el.classList[this.state.isOpen ? 'remove' : 'add']('is-visible');
    this.state.isOpen = !this.state.isOpen;
  }
}